import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import clientConfig from '../../../../../common/config';
import ProductThumbnail from '../../../shared/ProductThumbnail/ProductThumbnail';
import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import Link from '../../../shared/Link/Link';
import { css } from '@emotion/core';

import './ProductsCarouselByTag.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';
import SmallProductThumbnail from '../../../shared/ProductThumbnail/SmallProductThumbnail';
import { capitalize } from '../../../shared/lib/capitalize';

const API_ROOT_URL = clientConfig.apiBaseHost + clientConfig.apiBasePath;

class ProductsCarouselByTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTags: [],
      dataProducts: [],
    };
  }
  componentDidMount() {
    this._fetchTagAndProducts();
  }

  _fetchTagAndProducts = async () => {
    try {
      const { seoName } = this.props;

      const tags = await axios.get(`${API_ROOT_URL}/tags?pageSize=100`, {
        headers: {
          storeId: this.props.storeId,
        },
      });

      const products = await axios.get(
        `${API_ROOT_URL}/tags/${seoName}/products`,
        {
          headers: {
            storeId: this.props.storeId,
          },
        }
      );

      this.setState({
        dataTags: tags.data.items,
        dataProducts: products.data.items,
      });
    } catch (err) {
      console.error(err);
    }
  };

  renderProductsCarouselByTag = () => {
    if (this.props.isMobile) {
      return this.renderProductsCarouselByTagMobile();
    } else {
      return this.renderProductsCarouselByTagDesktop();
    }
  };

  renderProductsCarouselByTagDesktop = () => {
    const { dataTags, dataProducts } = this.state;
    const { seoName } = this.props;
    const seoNameTag = dataTags.find(
      item => item.seoName.toLowerCase() === seoName.toLowerCase()
    );
    const parentName = 'ProductsCarouselByTag';

    return (
      <div className="container products-carousel-by-tag-container">
        <h2 style={{ display: 'none' }}>
          Tag {capitalize(seoName.split('-').join(' '))}
        </h2>
        <div className="tag-card">
          {seoNameTag && (
            <Link to={`/tag/${seoName}`}>
              <ImageDispatcher src={seoNameTag.imageUrl} alt={seoName} />
            </Link>
          )}
        </div>
        <div className="product-cards">
          <ItemSlider
            loading={this.props.loading}
            primaryColor={this.props.primaryColor}
            secondaryColor={this.props.secondaryColor}
            sliderCircleArrowsProducts={this.props.sliderCircleArrowsProducts}
            productsCarouselVersion={2}
            parentName={parentName}
          >
            {dataProducts.map(product => (
              <ProductThumbnail
                product={product}
                productsThumbnail={this.props.productsThumbnail}
                productsCarouselVersion={2}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
              />
            ))}
          </ItemSlider>
        </div>
      </div>
    );
  };

  renderProductsCarouselByTagMobile = () => {
    const { dataTags, dataProducts } = this.state;
    const { seoName } = this.props;
    const seoNameTag = dataTags.find(
      item => item.seoName.toLowerCase() === seoName.toLowerCase()
    );

    const productsCarouselStyle = css`
      position: relative;
      width: 100%;
      overflow: hidden;
      padding: 1rem;
      max-width: unset;

      ::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${this.props.primaryColor};
        z-index: 0;
      }

      .tag-card {
        z-index: 1;

        img {
          box-shadow: 0px 0px 32px 16px rgba(0, 0, 0, 0.1);
        }
      }

      .products-container {
        margin-top: 16px;
      }

      .visible-content {
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0px 0px 32px 16px rgba(0, 0, 0, 0.1);
        background-color: white;

        img {
          width: 100% !important;
        }
      }
    `;

    const sliceToEven = array => {
      let length = array.length;
      if (length > 4) {
        length = 4;
      } else {
        // If the length is odd, subtract 1 to make it even
        if (length % 2 !== 0) {
          length -= 1;
        }
      }
      return array.slice(0, length);
    };

    return (
      <div
        className="products-carousel-by-tag-container"
        css={productsCarouselStyle}
      >
        <h2 style={{ display: 'none' }}>
          Tag {capitalize(seoName.split('-').join(' '))}
        </h2>
        <div className="tag-card">
          {seoNameTag && (
            <Link to={`/tag/${seoName}`}>
              <ImageDispatcher src={seoNameTag.imageUrl} alt={seoName} />
            </Link>
          )}
          <div className="products-container">
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}
            >
              {sliceToEven(dataProducts).map((product, index) => {
                return (
                  <div style={{ width: '48%' }} className="mobile-thumbnail">
                    <SmallProductThumbnail
                      key={product.id}
                      product={product}
                      list="Latest/Bestsellers slider"
                      productsCarouselVersion={
                        this.props.productsCarouselVersion
                      }
                      primaryColor={this.props.primaryColor}
                      secondaryColor={this.props.secondaryColor}
                      coloredBackgroundProducts={
                        this.props.coloredBackgroundProducts
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div>
            <Link
              className="btn btn-secondary"
              to={`/tag/${seoName}`}
              style={{
                width: '100%',
                height: 48,
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 4,
              }}
            >
              Vedi tutti
            </Link>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return this.renderProductsCarouselByTag();
  }
}
function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    storeId: state.store.data.storeId,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
  };
}
export default connect(mapStateToProps)(ProductsCarouselByTag);
